import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import get from 'lodash/get';

import {
  closeMenuItemAndGoToMenu,
  handleFormItemSubmit,
  fetchMenuItemEntity
} from 'bento-ordering/menus/actions/menuItem';
import {
  getMenuItemImage,
  getMenuItem
} from 'bento-ordering/menus/reducers/menuItemsDetail';
import { trackAddToCart } from 'bento-ordering/base/actions/tracking';
import { toggleAlertStatus } from 'bento-ordering/base/actions/alertStatus';

import { ADD_TO_CART } from 'bento-ordering/menus/constants/ctaName';
import { MENU_ITEM_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
import { MENU_ITEMS_DETAIL } from 'bento-ordering/menus/constants/entities';
import { NO_SET_ADDRESS } from 'bento-ordering/base/constants/orderAlerts';

import Box from '@material-ui/core/Box';
import MenuItemDetailForm from 'bento-ordering/menus/containers/MenuItemDetailForm';
import MenuItemImage from 'bento-ordering/menus/components/MenuItemImage';
import MenuItemDescription from 'bento-ordering/menus/components/MenuItemDescription';
import ModalCloseButton from 'bento-ordering/base/ui_components/ModalCloseButton';
import withLoading from 'bento-ordering/base/hoc/withLoading';
import { areFulfillmentDeliveryOptionsSetSelector } from 'bento-ordering/cart/selectors';
import { productPreviewHelperSelectorMenuItem } from 'bento-ordering/menus/reducers/productPreview';
import { isLocationClosedSelector } from 'bento-ordering/locations/selectors';

class MenuItemDetail extends React.PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    selectedLocationIsClosed: PropTypes.bool,
    ...MENU_ITEM_PROPTYPES,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
        menuItemSlug: PropTypes.string
      })
    }),
    orderMaximum: PropTypes.string,
    menuItemImage: PropTypes.string
  };

  static defaultProps = {
    variants: []
  };

  componentDidMount() {
    const { menuItemSlug } = this.props.match.params;
    this.props.dispatch(fetchMenuItemEntity(menuItemSlug));
  }

  closeModal = () => {
    this.props.dispatch(closeMenuItemAndGoToMenu());
  };

  handleAddToCart = (values, props) => {
    const { dispatch, cart } = this.props;
    const latestItemQuantity = values.quantityInput || 1;
    const areFulfillmentDeliveryOptionsSet = areFulfillmentDeliveryOptionsSetSelector(
      cart
    );
    if (!areFulfillmentDeliveryOptionsSet) {
      dispatch(toggleAlertStatus(NO_SET_ADDRESS, { latestItemQuantity }));
    }
    dispatch(trackAddToCart(latestItemQuantity));
    return handleFormItemSubmit(values, props);
  };

  render() {
    const {
      selectedLocationIsClosed,
      orderMaximum,
      menuItemImage,
      description,
      name,
      spicy,
      vegetarian,
      vegan,
      kosher,
      halal,
      organic,
      dairy,
      peanut,
      tree_nut,
      dairy_free,
      peanut_free,
      tree_nut_free,
      egg,
      shellfish,
      wheat,
      egg_free,
      shellfish_free,
      gluten_free,
      fish,
      soy,
      fish_free,
      soy_free,
      calories,
      variants,
      id: productId,
      slug: productSlug,
      menuItemPreviewHelper
    } = this.props;
    if (selectedLocationIsClosed) {
      return <Redirect to="/" />;
    }
    return (
      <React.Fragment>
        <ModalCloseButton
          autoFocus
          handleClick={this.closeModal}
          isWhite={!!menuItemImage}
        />
        {menuItemImage && <MenuItemImage src={menuItemImage} />}

        <Box>
          <MenuItemDescription
            name={name}
            spicy={spicy}
            vegetarian={vegetarian}
            vegan={vegan}
            kosher={kosher}
            halal={halal}
            organic={organic}
            dairy={dairy}
            peanut={peanut}
            tree_nut={tree_nut}
            dairy_free={dairy_free}
            peanut_free={peanut_free}
            tree_nut_free={tree_nut_free}
            egg={egg}
            shellfish={shellfish}
            wheat={wheat}
            egg_free={egg_free}
            shellfish_free={shellfish_free}
            gluten_free={gluten_free}
            fish={fish}
            soy={soy}
            fish_free={fish_free}
            soy_free={soy_free}
            calories={calories}
            description={description}
          />
        </Box>
        <Box pl={2.5} pr={2.5} pb={2.5}>
          <MenuItemDetailForm
            variants={variants}
            productId={productId}
            productName={name}
            productSlug={productSlug}
            defaultCtaName={ADD_TO_CART}
            handleFormItemSubmit={(values, props) =>
              this.handleAddToCart(values, props)
            }
            orderMaximum={orderMaximum}
            {...menuItemPreviewHelper}
          />
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { menuItemSlug } = ownProps.match.params;

  const menuItem = getMenuItem(state.menuItemsDetail, menuItemSlug);
  const { cart, restaurantLocations } = state;
  const orderMaximum = get(cart, 'max_order_amount', 0);
  const selectedLocationId = cart.online_ordering_location;

  return {
    ...menuItem,
    cart,
    menuItemImage: getMenuItemImage(menuItem),
    selectedLocationIsClosed: isLocationClosedSelector(
      restaurantLocations,
      selectedLocationId
    ),
    orderMaximum,
    menuItemPreviewHelper: productPreviewHelperSelectorMenuItem(state)
  };
};

export default withRouter(
  connect(mapStateToProps)(withLoading(MenuItemDetail, MENU_ITEMS_DETAIL))
);
